import {Component, DoCheck, OnInit, AfterViewInit, ChangeDetectorRef} from '@angular/core';
import {ViewEncapsulation} from '@angular/core';

import {ColorPickerService} from 'ngx-color-picker';
import {SettingService, Setting} from "../../service/setting.service";


@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SettingsComponent implements DoCheck, AfterViewInit {

  title = 'app works!';

  keepAfterVoteBoxHidden = true;

  beforeVoteBoxIsActive = false;
  afterVoteBoxIsActive = false;

  spinnerIsHidden = true;

  voteBoxWrapperHeight: string;

  settings: Setting = new Setting();

  formTypes = ['Up and Downvote (Thumbs)', 'Rating (Text)', 'Rating (Smileys)'];

  constructor(private cpService: ColorPickerService, private settingService: SettingService, private cdRef:ChangeDetectorRef) {
  }

  public ngDoCheck() {
    this.setVoteBoxWrapperHeight();

  }

  ngAfterViewInit(): void {
    this.getSettings();
    this.cdRef.detectChanges();

  }

  public activateBeforeVoteBox() {
    this.beforeVoteBoxIsActive = true;
    this.afterVoteBoxIsActive = false;
  }

  public activateAfterVoteBox() {
    this.keepAfterVoteBoxHidden = false;
    this.beforeVoteBoxIsActive = false;
    this.afterVoteBoxIsActive = true;
  }

  public setVoteBoxWrapperHeight() {
    let beforeForm = <HTMLElement>document.getElementById('beforeForm');
    let afterForm = <HTMLElement>document.getElementById('afterForm');
    console.log('beforeF: ' + beforeForm.offsetHeight + ' afterF: ' + afterForm.offsetHeight);
    this.voteBoxWrapperHeight = (Math.max(beforeForm.offsetHeight, afterForm.offsetHeight) + 64) + "px";
  }

  public getSettings(): void {
    this.spinnerIsHidden = false;
    this.beforeVoteBoxIsActive = false;
    this.afterVoteBoxIsActive = false;

    this.delay(2000).then(() => {
      this.settingService.getSetting().then(
          setting => {
            this.settings = setting;
            this.activateBeforeVoteBox();
            this.spinnerIsHidden = true;
          }
      );
    });
  }

  public updateSettings(): void {
    this.settingService.updateSetting(this.settings).then(
        response => console.log(response)
    )
  }

  public deleteSettings(): void {
    this.settingService.deleteSetting().then(
        response => this.getSettings()
    );
  }

  private delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}


// WEBPACK FOOTER //
// ./src/app/settings/settings/settings.component.ts